module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="richtext-body">' +
((__t = ( value )) == null ? '' : __t) +
'</span>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./~/icarus-forms/module/js/templates/controls/richtext.ejs
// module id = 207
// module chunks = 2 3